import Lot from './Lot.jsx';

export default Lot;
